import { Box, RadioGroup } from "@mui/material";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import {
  LocationResolutionFilterData,
  LocationResolutionFilterMetadata,
  LocationResolutionType,
} from "@/types/playground";

import { PlaygroundFilterSectionTitle } from "../PlaygroundFilterSectionTitle";
import { LocationTypeGroupFilterOption } from "./LocationTypeGroupFilterOption";
import { LocationTypeGroupFilterOptionType } from "./types";

const locationTypeGroupFilterOptions: LocationTypeGroupFilterOptionType[] = [
  {
    label: "filter.locationResolutionGroup.postalCode",
    type: LocationResolutionType.PostalCode,
  },
];

export type LocationResolutionSectionProps = {
  postalCode: string;
  setPostalCode: (postalCode: string) => void;
  onEnterPostalCodeValue: () => void;
  locationResolution: LocationResolutionFilterData;
  onLocationResolutionChange: (locationResolutionData: LocationResolutionFilterData) => void;
  onLocationResolutionMetadataChange: (metadata: LocationResolutionFilterMetadata) => void;
};

export const LocationResolutionSection = ({
  postalCode,
  setPostalCode,
  onEnterPostalCodeValue,
  locationResolution,
  onLocationResolutionChange,
  onLocationResolutionMetadataChange,
}: LocationResolutionSectionProps): JSX.Element => {
  const { t } = useTranslation("PlaygroundPage");

  const onLocationTypeGroupChange = (_event: React.ChangeEvent<HTMLInputElement>, value: string): void => {
    onLocationResolutionChange({ ...locationResolution, type: value as LocationResolutionType });
  };

  return (
    <Box sx={{ p: "13px 20px" }}>
      <PlaygroundFilterSectionTitle title={t("filter.locationResolutionGroup.title")} />
      <RadioGroup value={locationResolution.type} onChange={onLocationTypeGroupChange}>
        {locationTypeGroupFilterOptions.map((locationTypeGroupFilterOption, index) => (
          <Box
            key={locationTypeGroupFilterOption.type}
            sx={{
              ...(index < locationTypeGroupFilterOptions.length - 1 && { mb: 1 }),
            }}
          >
            <LocationTypeGroupFilterOption
              postalCode={postalCode}
              setPostalCode={setPostalCode}
              onEnterPostalCodeValue={onEnterPostalCodeValue}
              locationTypeGroupFilterOption={locationTypeGroupFilterOption}
              locationResolution={locationResolution}
              onLocationResolutionMetadataChange={onLocationResolutionMetadataChange}
            />
          </Box>
        ))}
      </RadioGroup>
    </Box>
  );
};
